var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"row ml-3"},[_c('iframe',{attrs:{"src":"https://forewarn.compegence.com:3000/#!/l1/Product%20Category/state","height":"600","width":"100%","frameBorder":"0"}})])])
}]

export { render, staticRenderFns }